import React from 'react';
import {
    Card,
    CardActionArea,
    CardMedia,
    Typography,
    Box,
    Button,
} from '@mui/material';
import RestauLocationMappingDialog from './RestauLocationMappingDialog.js';

export default function CloverIntegration({ onIntegrationComplete }) {
    const [cloverLocations, setCloverLocations] = React.useState([]);
    const [showMappingDialog, setShowMappingDialog] = React.useState(false);
    const [merchantId, setMerchantId] = React.useState(null);

    // Sample existing mappings for demo - includes BOTH Square and Clover mappings
    const SAMPLE_ALL_EXISTING_MAPPINGS = [
        { restauId: 'restau_001', locationId: 'L123ABC', posType: 'square' },
        { restauId: 'restau_002', locationId: 'L456DEF', posType: 'square' },
        {
            restauId: 'restau_003',
            locationId: 'CLOVER_L001',
            posType: 'clover',
        },
    ];

    const initiateCloverOAuth = () => {
        // TODO: Implement actual Clover OAuth flow
        alert('To be implemented');
    };

    const handleSaveMappings = (mappings, merchantId) => {
        console.log('Saving Clover mappings:', mappings);
        console.log('Merchant ID:', merchantId);

        // TODO: Save to Firebase
        // For now, just show success message
        alert(`Successfully created ${mappings.length} Clover mapping(s)!`);
        setShowMappingDialog(false);

        if (onIntegrationComplete) {
            onIntegrationComplete();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: { xs: '100%', sm: 'auto' },
            }}
        >
            {/* Clover POS Card */}
            <Card
                sx={{
                    width: { xs: '100%', sm: 140 },
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: '1px solid #e0e0e0',
                    '&:hover': { boxShadow: 3, transform: 'translateY(-2px)' },
                }}
                onClick={initiateCloverOAuth}
            >
                <CardActionArea>
                    <Box
                        sx={{
                            p: 1.5,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <CardMedia
                            component="img"
                            sx={{
                                width: 80,
                                height: 80,
                                objectFit: 'contain',
                                mb: 1,
                            }}
                            image="https://storage.googleapis.com/sliceq-takeout/Clover.png"
                            alt="Clover POS"
                        />
                        <Typography variant="body1">Clover POS</Typography>
                    </Box>
                </CardActionArea>
            </Card>

            {/* Start Integration Button */}
            <Box sx={{ mt: 2 }}>
                <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={initiateCloverOAuth}
                    fullWidth
                >
                    Connect Clover
                </Button>
            </Box>

            {/* Mapping Dialog */}
            <RestauLocationMappingDialog
                open={showMappingDialog}
                onClose={() => setShowMappingDialog(false)}
                onSave={handleSaveMappings}
                posType="clover"
                posLocations={cloverLocations}
                existingMappings={SAMPLE_ALL_EXISTING_MAPPINGS}
                merchantId={merchantId}
            />
        </Box>
    );
}
